export const customerTypes = {
  Company: 1,
  Person: 2,
}
